<!-- 公共空状态组件 -->
<template>
    <div class="commonEmptyBox">
        <van-empty :image="errorUrl" :description="description || $t('empty.commonEmpty')" :image-size="imageSize" />
    </div>
</template>

<script>
import { EMPTY_ENUM } from "@/utils/constant"; // 引入空状态枚举
export default {
    props: {
        // 描述文字
        description: {
            type: String,
            default: '',
        },
        // 图片类型，可选值：空状态枚举
        errorType: {
            type: String,
            default: 'searchEmpty',
        },
        // 图片大小 - 单位px
        imageSize: {
            type: String,
            default: '70',
        },
    },
    data() {
        return {
            emptyObj: EMPTY_ENUM,
        };
    },
    computed: {
        errorUrl() {
            return this.emptyObj[this.errorType];
        }
    },
    methods: {},
};
</script>

<style scoped>
.commonEmptyBox {
    width: 100%;
    height: auto;
}
</style>